// material-ui
import { Box, IconButton, Link, useMediaQuery, Typography } from '@mui/material';
import { GithubOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';

// project import
import Search from './Search';
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';
import TitleSection from './TitleSection';
import Cart from './Cart';
import Cookies from "js-cookie";
import LoginActionModal from 'core/components/login/LoginActionModal';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const {userprofileInfo} = useSelector((state)=>state.headerslice);

  return (
    <>
      {/* Centered logo */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',      // vertical center
          justifyContent: 'center',  // horizontal center
          width: '100%',
          height: '100%',            // ensures vertical centering within header height
          minHeight: 48              // adjust as per your header height
        }}
      >
        <img
          src="/gnr-logo.jpeg"
          alt="GNR Logo"
          style={{ height: 48, display: 'block' }}
        />
        {/* <Typography variant="h5" sx={{  color: 'primary.darker', }}>glamourr & radiance </Typography> */}
      </Box>
      {!matchesXs && <TitleSection />}
      {matchesXs && <Box sx={{ width: '100%', ml: 1 }} />}
      
      {/* <IconButton
        component={Link}
        href="https://github.com/codedthemes/mantis-free-react-admin-template"
        target="_blank"
        disableRipple
        color="secondary"
        title="Download Free Version"
        sx={{ color: 'text.primary', bgcolor: 'grey.100' }}
      >
        <GithubOutlined />
      </IconButton> */}

      <Cart/>
      {/* <Notification /> */}
      {!matchesXs && <Profile />}
      {matchesXs && <MobileSection />}
      <LoginActionModal/>
    </>
  );
};

export default HeaderContent;
